export const SOCIO_EMPRESA_HISTORICO = [
  {
    "cnpj": "03763656000154",
    "inCpfCnpjSocio": "2",
    "niSocio": "21772986879",
    "qualificacaoSocio": "Sócio-Administrador",
    "dataInclusao": "20000418",
    "dataExclusao": "20110527",
    "capitalSocial": null,
    "cpfRepresentanteLegal": "00000000000",
    "qualificacaoRepresentanteLegal": null,
    "pais": null,
    "nomeSocio": "GSRZTL NLIVML UVIRZMR"
  }
];
